// extracted by mini-css-extract-plugin
export var checkbox = "_9m-0";
export var circle = "_9m-3";
export var horizontalContainer = "_9m-7";
export var sm = "_9m-5";
export var switch0 = "_9m-2";
export var switchDisabled = "_9m-8";
export var switchEnabled = "_9m-1";
export var textSwitchContainer = "_9m-9";
export var textSwitchOption = "_9m-a";
export var textSwitchOptionSelected = "_9m-b";
export var verticalContainer = "_9m-6";
export var xs = "_9m-4";